import { defineEntity, custom } from './_helpers.js';

export default defineEntity('riskRegister', {
    statusChanged: custom({ scope: 'state' }),
    treatmentAdded: custom({ scope: 'state' }),
    biasLinked: custom({ scope: 'state' }),
    biaUnlinked: custom({ scope: 'state' }),
    objectivesLinked: custom({ scope: 'state' }),
    objectiveUnlinked: custom({ scope: 'state' }),
});
